import React from 'react';
import Header from '../AssetHealthApp/Header';
import TreeView from './TreeView';

export default function Dashboard() {
  return (
    <>
      <Header BrandText={'Hierarchy'} />
      <TreeView />
    </>
  );
}
